import React from 'react'
import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableRow,
  Typography
} from '@mui/material'

const TableListLoading = ({ rowsPerPage = 50, currentPeriodicalReport }) => {
  const styles = currentPeriodicalReport?.previousPeriodicalReportId ? { padding: '0 0.5rem' } : {}
  const previousPeriodicalReport = currentPeriodicalReport?.previousPeriodicalReportId
  const assessmentAreasRatings = currentPeriodicalReport?.ratings

  const effortAndConductOps = currentPeriodicalReport?.effortAndConductOptions?.filter((option) =>
    option?.view.includes('by-assessment-area')
  )
  const colSpanEC = effortAndConductOps?.length > 0 ? effortAndConductOps.length : 0
  const colSpanRatings = assessmentAreasRatings?.length > 0 ? 1 : 0

  return (
    <>
      <TableContainer className='absolute inset-0 flex flex-col' component={Box}>
        <Table>
          <TableHead className='sticky top-0px z-10'>
            <TableRow>
              <TableCell
                rowSpan={3}
                style={{
                  outline: '1px solid var(--muted)'
                }}
              >
                <Typography variant='inherit' className='flex '>
                  Students (<Skeleton variant='text' width={30} />)
                </Typography>
              </TableCell>
              {previousPeriodicalReport && (
                <TableCell
                  key={`periodical-assessment-area-group-prev`}
                  colSpan={3}
                  className='text-center'
                  style={{
                    outline: '1px solid var(--muted)',
                    background: 'rgb(230 234 239)',
                    ...styles
                  }}
                >
                  <Typography variant='body2' className='font-bold'>
                    previous Assessment Area
                  </Typography>
                  <div className='flex justify-center items-center'>
                    <Typography variant='subtitle2' className='font-bold text-lg text-center'>
                      {previousPeriodicalReport?.code || <Skeleton variant='text' width={100} />}
                    </Typography>
                  </div>
                </TableCell>
              )}
              <TableCell
                key={`periodical-assessment-area-group-current`}
                colSpan={3 + colSpanEC + colSpanRatings}
                className='text-center'
                style={{
                  padding: '0 0.5rem',
                  outline: '1px solid var(--muted)'
                }}
              >
                <Typography variant='body2' className='font-bold'>
                  current Assessment Area
                </Typography>
                <div className='flex justify-center items-center'>
                  <Typography variant='subtitle2' className='font-bold text-lg text-center'>
                    {currentPeriodicalReport?.code || <Skeleton variant='text' width={100} />}
                  </Typography>
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              {previousPeriodicalReport?._id && (
                <>
                  <TableCell
                    key={`period-previous-assessment-area-code-${previousPeriodicalReport?._id}`}
                    className='text-center'
                    width={80}
                    style={{
                      outline: '1px solid var(--muted)',
                      background: 'rgb(230 234 239)'
                    }}
                  >
                    code
                  </TableCell>
                  <TableCell
                    key={`period-previous-assessment-area-name-${previousPeriodicalReport?._id}`}
                    className='text-center'
                    width={150}
                    style={{
                      outline: '1px solid var(--muted)',
                      background: 'rgb(230 234 239)'
                    }}
                  >
                    name
                  </TableCell>
                  <TableCell
                    key={`period-previous-level-${previousPeriodicalReport?._id}`}
                    className='text-center'
                    width={80}
                    style={{
                      outline: '1px solid var(--muted)',
                      background: 'rgb(230 234 239)'
                    }}
                  >
                    level
                  </TableCell>
                </>
              )}
              <TableCell
                key={`period-current-assessment-area-code-${currentPeriodicalReport?._id}`}
                className='text-center'
                width={80}
                style={{
                  outline: '1px solid var(--muted)'
                }}
              >
                code
              </TableCell>
              <TableCell
                key={`period-current-assessment-area-name-${currentPeriodicalReport?._id}`}
                className='text-center'
                width={150}
                style={{
                  outline: '1px solid var(--muted)'
                }}
              >
                name
              </TableCell>
              <TableCell
                key={`period-current-level-${currentPeriodicalReport?._id}`}
                className='text-center'
                width={80}
                style={{
                  outline: '1px solid var(--muted)'
                }}
              >
                level
              </TableCell>
              {assessmentAreasRatings?.length > 0 && (
                <TableCell
                  className='text-center'
                  width={150}
                  style={{
                    outline: '1px solid var(--muted)'
                  }}
                >
                  Rating
                </TableCell>
              )}
              {effortAndConductOps?.length > 0 && (
                <TableCell
                  className='text-center'
                  style={{
                    outline: '1px solid var(--muted)'
                    // background: 'rgba(32, 0, 150, 0.05)'
                  }}
                >
                  Effort and Conduct
                </TableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody key={`table-body-loading-periodical-report-marking`}>
            {[...Array(rowsPerPage).keys()].map((index) => (
              <TableRow key={`row-loading-${index}`}>
                <TableCell>
                  <Skeleton variant='text' />
                  <Skeleton variant='text' width={'50%'} />
                </TableCell>
                {currentPeriodicalReport?.previousPeriodicalReportId && (
                  <>
                    <TableCell
                      key={`period-assessment-area-code`}
                      className='text-center'
                      width={80}
                      style={{
                        outline: '1px solid var(--muted)',
                        background: 'rgb(230 234 239)'
                      }}
                    >
                      <Skeleton variant='text' />
                    </TableCell>
                    <TableCell
                      key={`period-assessment-area-name`}
                      className='text-center'
                      width={150}
                      style={{
                        outline: '1px solid var(--muted)',
                        background: 'rgb(230 234 239)'
                      }}
                    >
                      <Skeleton variant='text' />
                    </TableCell>
                    <TableCell
                      key={`period-previous-${currentPeriodicalReport?.previousPeriodicalReportId}`}
                      className='text-center'
                      width={100}
                      style={{
                        outline: '1px solid var(--muted)',
                        background: 'rgb(230 234 239)'
                      }}
                    >
                      <Skeleton variant='text' />
                    </TableCell>
                  </>
                )}
                <TableCell
                  key={`period-assessment-area-code`}
                  className='text-center'
                  width={80}
                  style={{
                    outline: '1px solid var(--muted)'
                  }}
                >
                  <Skeleton variant='text' />
                </TableCell>
                <TableCell
                  key={`period-assessment-area-name`}
                  className='text-center'
                  width={150}
                  style={{
                    outline: '1px solid var(--muted)'
                  }}
                >
                  <Skeleton variant='text' />
                </TableCell>
                <TableCell
                  key={`period-previous-${currentPeriodicalReport?.previousPeriodicalReportId}`}
                  className='text-center'
                  width={100}
                  style={{
                    outline: '1px solid var(--muted)'
                  }}
                >
                  <Skeleton variant='text' />
                </TableCell>
                {assessmentAreasRatings?.length > 0 && (
                  <TableCell
                    className='text-center'
                    style={{
                      outline: '1px solid var(--muted)'
                    }}
                  >
                    <Skeleton variant='text' />
                  </TableCell>
                )}
                {effortAndConductOps?.length > 0 && (
                  <TableCell
                    className='text-center'
                    style={{
                      outline: '1px solid var(--muted)'
                      // background: 'rgba(32, 0, 150, 0.05)'
                    }}
                  >
                    <Skeleton variant='text' />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default React.memo(TableListLoading)
